import React, { useEffect, useState } from "react";
import { Grid, Box, Button, IconButton, Modal, Typography } from "../../components/ui";
import { Add, Delete, Edit } from "../../components/icons";
import { toast } from "react-toastify";
import axiosInstance from "../../axios/axiosInstance";
import { modalStyle } from "../../style/common";
import RelationshipForm from "./components/RelationshipForm";

const Relationship = () => {
  const [open, setOpen] = useState<boolean>(false);
  const [relationship, setRelationship] = useState<any>([]);
  const [id, setId] = useState<any>(null);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    handleGetRelationship();
    setId(null);
  };

  const handleGetRelationship = async () => {
    try {
      const resp: any = await axiosInstance.get(`/api/relationship`);
      if (resp?.status === 200) {
        setRelationship(resp?.data?.data);
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.body);
    }
  };
  const handleDelete = async (id: any) => {
    try {
      const resp: any = await axiosInstance.delete(`/api/relationship/${id}`);
      if (resp?.status === 200) {
        handleGetRelationship();

        toast.success("Deleted successfully");
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.body);
    }
  };

  useEffect(() => {
    handleGetRelationship();
  }, []);
  return (
    <div>
      <Grid container p={2} px={{ md: 10, xs: 5 }}>
        <Grid size={12}>
          <Button onClick={handleOpen} sx={{ textTransform: "none" }}>
            <Typography fontSize={20} fontWeight={500} color="#111827">
              Relationship
              <IconButton onClick={handleOpen}>
                <Add sx={{ color: "#111827" }} />
              </IconButton>
            </Typography>
          </Button>
        </Grid>
        <Grid
          size={12}
          container
          mt={2}
          py={1}
          bgcolor={"#111827"}
          borderRadius={1}
          color={"whitesmoke"}
        >
          <Grid size={1}>
            <Typography fontSize={17} fontWeight={500} align="center">
              Sl no
            </Typography>
          </Grid>
          <Grid size={2}>
            <Typography fontSize={17} fontWeight={500} align="center">
              Person
            </Typography>
          </Grid>
          <Grid size={2}>
            <Typography fontSize={17} fontWeight={500} align="center">
              Person of
            </Typography>
          </Grid>
          <Grid size={2}>
            <Typography fontSize={17} fontWeight={500} align="center">
              Relation
            </Typography>
          </Grid>
          <Grid size={2}>
            <Typography fontSize={17} fontWeight={500} align="center">
              Marriage{" "}
            </Typography>
          </Grid>
          <Grid size={3}>
            <Typography fontSize={17} fontWeight={500} align="center">
              Action
            </Typography>
          </Grid>
        </Grid>
        {relationship?.map((item: any, index: any) => (
          <Grid size={12} container borderBottom={"1px solid #111827"} py={2}>
            <Grid size={1}>
              <Typography fontSize={17} align="center">
                {" "}
                {index + 1}
              </Typography>
            </Grid>
            <Grid size={2}>
              <Typography fontSize={17} fontWeight={500} align="center">
                {item?.person?.name}
              </Typography>
            </Grid>
            <Grid size={2}>
              <Typography fontSize={17} fontWeight={500} align="center">
                {item?.ofPerson?.name}
              </Typography>
            </Grid>
            <Grid size={2}>
              <Typography fontSize={17} fontWeight={500} align="center">
                {item?.relation}
              </Typography>
            </Grid>
            <Grid size={2}>
              <Typography fontSize={17} fontWeight={500} align="center">
                {item?.marriage?.man?.name} - {item?.marriage?.woman?.name}
              </Typography>
            </Grid>
            <Grid
              size={3}
              sx={
                item?.is_request_send && {
                  pointerEvents: "none",
                  opacity: 0.6,
                }
              }
            >
              <Typography fontSize={17} align="center">
                <IconButton
                  onClick={() => {
                    setId(item?.id);
                    handleOpen();
                  }}
                >
                  <Edit sx={{ color: "#111827" }} />
                </IconButton>
                <IconButton onClick={() => handleDelete(item?.id)}>
                  <Delete sx={{ color: "#111827" }} />
                </IconButton>
              </Typography>
            </Grid>
          </Grid>
        ))}
      </Grid>
      <Modal onClose={handleClose} open={open}>
        <Box sx={modalStyle}>
          <RelationshipForm onClose={handleClose} id={id} />
          {/* <BlockFrom onClose={handleClose} id={id} /> */}
        </Box>
      </Modal>
    </div>
  );
};

export default Relationship;
